import { render, staticRenderFns } from "./resource-file.vue?vue&type=template&id=01bcc54c"
import script from "./resource-file.vue?vue&type=script&lang=ts"
export * from "./resource-file.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports